import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=1959dd48&scoped=true"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=1959dd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959dd48",
  null
  
)

export default component.exports